import CookieManager from "./cookieManager";

export default class AcceptCookiesManager {
    constructor(cookieName, alwaysEnabled = false, bypassUserPreference = false) {
        this.cookieManager = new CookieManager;
        this.cookieName = cookieName;
        this.cookiesStatus = false;
        this.alwaysEnabled = alwaysEnabled;
        this.bypassUserPreference = bypassUserPreference;
        let element = document.querySelector('[data-entity="accept-cookies"]');

        if (!element) {
            return;
        }

        if (this.bypassUserPreference) {
            this.cookiesStatus = AcceptCookiesManager.granted;
            let cookieValue = this.cookieManager.getCookie(cookieName);
            if (cookieValue) {
                this.modifyAcceptCookie(element, AcceptCookiesManager.cookieGranted, 730, AcceptCookiesManager.granted)
            } else {
                element.style.display = '';
                this.eventDelegation(element);
            }
            return;
        }

        if (this.alwaysEnabled) {
            this.cookiesStatus = AcceptCookiesManager.granted
            element.remove();
            return;
        }
        let cookieValue = this.cookieManager.getCookie(cookieName);
        if (cookieValue) {
            cookieValue = decodeURIComponent(cookieValue);
            element.remove();
            if (cookieValue == AcceptCookiesManager.cookieDenied) {
                this.cookiesStatus = AcceptCookiesManager.denied;
            } else {
                this.cookiesStatus = AcceptCookiesManager.granted;
            }
        } else{
            element.style.display = '';
            this.eventDelegation(element);
        }
    }

    eventDelegation(element) {
        document.querySelector('[data-action="reject-cookies"]').addEventListener('click', () => {
            this.modifyAcceptCookie(element, AcceptCookiesManager.cookieDenied, 30, AcceptCookiesManager.denied);
        });

        document.querySelector('[data-action="accept-cookies"]').addEventListener('click', () => {
            this.modifyAcceptCookie(element, AcceptCookiesManager.cookieGranted, 730, AcceptCookiesManager.granted);
        });
    }

    modifyAcceptCookie(element, content, expireDays, cookiesStatus) {
        if (this.bypassUserPreference) {
            this.cookieManager.setCookie(this.cookieName, AcceptCookiesManager.cookieGranted, expireDays, "/");
            this.cookiesStatus = AcceptCookiesManager.granted;
            element.remove();
            return;
        }

        this.cookieManager.setCookie(this.cookieName, content, expireDays, "/");
        element.remove();
        this.cookiesStatus = cookiesStatus;
        let event = new Event(AcceptCookiesManager.onLoadEvent);
        document.querySelector('[data-entity="google-tag-manager-script"]').dispatchEvent(event);
    }
}

AcceptCookiesManager.onLoadEvent = 'on-modify-cookie-accept';
AcceptCookiesManager.cookieGranted = 'necessary:true_preferences:true_statistics:true_marketing:true';
AcceptCookiesManager.cookieDenied = 'necessary:false_preferences:false_statistics:false_marketing:false';
AcceptCookiesManager.granted = 'granted';
AcceptCookiesManager.denied = 'denied';
